export default {
  frameFilter: {
    filterTitle: '滤镜',
  },
  frameLoop: {
    cycleIndex: '循环次数',
    title: '播放设置',
    sequence: '次',
    LoopPlayback: '无限循环',
  },
  perFrameDrag: {
    addTitle: '添加图片',
    playAction: '播放序列帧',
    stopAction: '暂停序列帧',
    frameTitle: '每帧图片',
    removeImageWarn: '序列帧至少需要一张图片',
    uploading: '上传中...',
  },
  perFrameInterval: {
    frameTitle: '每帧播放间隔',
  },
}
